import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum WordCategory {
    Fruit = "fruit",
    Instrument = "instrument",
    Clothes = "clothes",
    Vegetable = "vegetable",
    Profession = "profession",
    Animal = "animal",
    Beverage = "beverage",
    Household = "household",
    School = "school"
}

export enum WordResponseType {
    Correct = "correct",
    Intrusion = "intrusion",
    OutOfScope = "outOfScope",
    Incorrect = "incorrect"
}

export interface Word {
    id: number;
    value: string;
    category: WordCategory;
    alternates: string[];
    audioInstructionUrl: string;
}

export interface WordList {
    id: number;
    name: string;
    words: Word[];
}

export interface Intrusion {
    id: number;
    value: string;
    category: WordCategory;
    alternates: string[];
}

export interface Assessment {
    id: number;
    assessmentFormId: number;
    locationId: number;
    wordLists: WordList[];
    intrusions: Intrusion[];
}

export interface WordAlternates {
    alternates: Word[];
    list: number;
}

export const initialState: Assessment = {
    id: 0,
    assessmentFormId: 0,
    locationId: 0,
    wordLists: [],
    intrusions: []
};

const assessmentSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        updateAssessment(state, action: PayloadAction<Assessment>) {
            state.id = action.payload.id;
            state.assessmentFormId = action.payload.assessmentFormId;
            state.wordLists = action.payload.wordLists;
            state.intrusions = action.payload.intrusions;
            state.locationId = action.payload.locationId;
        },
        updateAlternates(state, action: PayloadAction<WordAlternates>) {
            state.wordLists[action.payload.list].words = action.payload.alternates;
        }
    }
});

export const { updateAssessment, updateAlternates } = assessmentSlice.actions;

export default assessmentSlice.reducer;
